const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const validateEmail = (email) => {
  if (!email || typeof email !== 'string') {
    return false;
  }
  return emailPattern.test(email);
};
